import * as React from "react";
function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_40002073_54185)">
        <rect width="34" height="34" rx="17" fill="#F1F2F4" />
        <rect x="-3" y="-3" width="40" height="40" rx="20" fill="#F1F2F4" />
        <path
          d="M5.84493 37H28.1551C29.0425 37 29.7385 36.8091 30.2431 36.4274C30.7477 36.0456 31 35.5214 31 34.8547C31 33.8225 30.6756 32.7311 30.0269 31.5806C29.378 30.4301 28.4463 29.3521 27.2317 28.3467C26.0173 27.3413 24.5477 26.5241 22.8229 25.8951C21.0983 25.266 19.1545 24.9515 16.9917 24.9515C14.84 24.9515 12.9018 25.266 11.1771 25.8951C9.45238 26.5241 7.98001 27.3413 6.75996 28.3467C5.53991 29.3521 4.60824 30.4301 3.96495 31.5806C3.32165 32.7311 3 33.8225 3 34.8547C3 35.5214 3.25233 36.0456 3.75698 36.4274C4.26164 36.8091 4.95762 37 5.84493 37ZM17.0084 22.0645C18.1951 22.0645 19.2932 21.75 20.3024 21.1209C21.3117 20.4919 22.1242 19.6398 22.7398 18.5645C23.3554 17.4892 23.6632 16.2796 23.6632 14.9355C23.6632 13.6129 23.3554 12.4274 22.7398 11.379C22.1242 10.3306 21.3117 9.50538 20.3024 8.90322C19.2932 8.30107 18.1951 8 17.0084 8C15.8216 8 14.7235 8.30645 13.7142 8.91935C12.7049 9.53226 11.8925 10.3656 11.2769 11.4193C10.6613 12.4731 10.3536 13.6559 10.3536 14.9677C10.3536 16.3011 10.6613 17.5027 11.2769 18.5726C11.8925 19.6424 12.7049 20.4919 13.7142 21.1209C14.7235 21.75 15.8216 22.0645 17.0084 22.0645Z"
          fill="url(#paint0_linear_40002073_54185)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_40002073_54185"
          x1="17"
          y1="4.27143"
          x2="16.9356"
          y2="58.4999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8A959E" />
          <stop offset="1" stop-color="#8A959E" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_40002073_54185">
          <rect width={width} height={height} rx="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgComponent;
